export const messages = {
  brand: "HandleQuest",
  heroTitle: "Claim the gamer tag before the lobby does.",
  heroCopy: "Check one name across gaming platforms, then generate sharper alternatives when your first pick is taken."
};

